import React from 'react'
import Rentree from '../../Page/Admis/rentree.js';

export default function ensiie() {
    return (
        <div className="divecole fifty">
            <div className='imglogopartnaire'>
                <img 
                    className='logoPartenaire' 
                    src="images/partenaire/ensiie1.png" 
                    style={{ paddingLeft: '0.2%', paddingBottom: '0.2%', width:"80%" }} 
                />
            </div>
            <br/> <br/>
            <a style={{ color: '#4e95ac', fontSize: '18px' }}>
                l'ENSIIE <Rentree />
            </a>
            <br/> <br/>
            <p style={{ fontWeight: "800", fontSize: "1.5rem" }}>
                ALMAMOUN OUSSAMA - <span style={{ color: "#4cb6ea", fontSize: "1.5rem" }}>4ème année Cycle Ingénieur en Informatique</span>
            </p>
            <p style={{ fontWeight: "800", fontSize: "1.5rem" }}>
                MAKHOKH CHAYMAE - <span style={{ color: "#4cb6ea", fontSize: "1.5rem" }}>4ème année Cycle Ingénieur en Informatique</span>
            </p>
            <p style={{ fontWeight: "800", fontSize: "1.5rem" }}>
                BZIOUI ANAS - <span style={{ color: "#4cb6ea", fontSize: "1.5rem" }}>4ème année Cycle Ingénieur en Informatique</span>
            </p>
            <p style={{ fontWeight: "800", fontSize: "1.5rem" }}>
                EL-GHOUALI AYMANE - <span style={{ color: "#4cb6ea", fontSize: "1.5rem" }}>4ème année Cycle Ingénieur en Informatique</span>
            </p>
        </div>
    )
}
